import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  version: "weekly",
  libraries: ["places", "geocoding"]
});

export const geocodeAddress = async (address: string) => {
  try {
    // Use the already loaded Google Maps instance
    if (!window.google) {
      throw new Error('Google Maps not loaded');
    }

    const geocoder = new google.maps.Geocoder();
    
    const result = await new Promise<google.maps.GeocoderResult | null>((resolve, reject) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          resolve(results[0]);
        } else {
          reject(new Error('Location not found'));
        }
      });
    });

    if (!result) {
      throw new Error('Location not found');
    }

    return {
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng()
    };
  } catch (error) {
    console.error('Geocoding error:', error);
    throw error;
  }
}; 